<div class="sale-horse-xray-reports-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">XRay Report <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>--></h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-4">
    <div class="row"  *ngIf="!isLoader">
      <div class="col-md-6 mb-2" *ngFor='let file of studyFiles; trackBy: index;'>

        <div class="p-3">
          <h5 class="text-primary pb-2">X-Ray Report</h5>
          <div class="row">
            <div class="col-md-6">
              <div class="xray-wrapper w-100">
                <div class="outlay-outer flex align-items-center justify-content-center">
                  <div class="outlay-inner flex align-items-center justify-content-center">
                    <i class="far fa-file-pdf"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="isClientNameRequired(file)">
              <div class="flex h-100 align-items-center">
                <form [formGroup]="file.scopeForm">
                  <label for="">Client Name</label>
                  <input type="text"
                         class="form-control"
                         formControlName="clientName" />
                  <p class="text-warning fs-13">
                    You must declare the client name to open the scope video
                  </p>
                </form>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="small-text fs-13 mt-2">
                Submitted by {{ file?.createdByUser.name }} <br />
                {{ file?.createdDate | date : "medium" }}
              </div>
            </div>
            <div class="col-md-6">
              <button class="btn btn-success w-100"
                      [disabled]="file?.scopeForm?.invalid"
                      (click)="openPdf(file,file?.scopeForm)">
                Open X-ray report
              </button>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
